<template>
    <div>
        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :busy="busy"
                :fields="fields"
                :items="items"
            >
                <template v-slot:cell(procedimento)="row">
                    <span
                        :title="row.item.procedimentoNome"
                        v-rkm-tooltip.hover
                    >
                        {{ row.item.procedimentoCodigo | formatProcedimento }}
                    </span>
                </template>

                <template v-slot:cell(ocupacao)="row">
                    <span
                        :title="row.item.ocupacaoNome"
                        v-rkm-tooltip.hover
                    >
                        {{ row.item.ocupacaoCodigo }}
                    </span>
                </template>

                <template v-slot:cell(actions)="row">
                    <rkm-button
                        @click="$refs.Modal.open(row.item)"
                        color="primary"
                        small
                        title="Visualizar"
                    >
                        <rkm-icon icon="eye" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal ref="Modal" />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import registro from '@/enums/sigtap/registro'

// Filters.
import formats from '@/filters/formats'

// Mixins
import { repository, object, stringCase, file } from '@/mixins'

// vuex
import { mapActions } from 'vuex'

export default {
    components: { Modal },
    computed: {
        fields() {
            if (this.registroCodigo === this.enums.registro.BPA_CONSOLIDADO) {
                return [
                    { key: 'origem', label: 'Origem' },
                    { key: 'unidadeNome', label: 'Unidade' },
                    { key: 'competenciaValor', label: 'Competência' },
                    { key: 'procedimento', label: 'Procedimento' },
                    { key: 'ocupacao', label: 'CBO' },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'idade', label: 'Idade' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            } else {
                return [
                    { key: 'origem', label: 'Origem' },
                    { key: 'unidadeNome', label: 'Unidade' },
                    { key: 'competenciaValor', label: 'Competência' },
                    { key: 'usuarioNome', label: 'Profissional' },
                    { key: 'ocupacao', label: 'CBO' },
                    { key: 'pacienteNome', label: 'Paciente' },
                    { key: 'procedimento', label: 'Procedimento' },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.bpa'),
        }
    },
    data: () => ({
        enums: { registro },
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        exportTo() {
            this.setLoading()

            this.repositories.exportacao.relatorioInconsistencia(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => {
                return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }
            })

            return data
        },
        prepareData() {
            const data = this.clone(this.model)
            return this.camelObjectKeysToSnakeRecursive(data);
        },
    },
    mixins: [repository, object, stringCase, file],
    props: {
        busy: { type: Boolean },
        items: { type: Array },
        registroCodigo: { type: String },
        model: { type: Object },
    },
}
</script>
